// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "button{border:none}.link-c7RvB{text-decoration:none}.text-PjlI6{color:hsla(0,0%,100%,.69)}.icon-Kt3Hv{opacity:.65}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": "link-c7RvB",
	"text": "text-PjlI6",
	"icon": "icon-Kt3Hv"
};
export default ___CSS_LOADER_EXPORT___;
